export default "__VITE_ASSET__D1eSB78w__"